module.exports = __webpack_public_path__ + "img/productDefault.c080d2ec.jpg";